import React from 'react';
import './HeaderCard.css';

const HeaderCard = ({ 
  icon, 
  title, 
  subtitle, 
  productName, 
  className = '' 
}) => {
  return (
    <div className={`header-card-compact ${className}`}>
      <div className="header-card-main">
        <div className="header-icon-small">
          <i className={`fa ${icon}`}></i>
        </div>
        <div className="header-text-content">
          <div className="header-title-container">
            <h4 className="header-title-small">{title}</h4>
            <span className="product-name-small">{productName}</span>
          </div>
          {subtitle && (
            <p className="header-subtitle-small">{subtitle}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeaderCard;